module.exports = __webpack_public_path__ + "static/media/Rounds-08.536051ee.png";